import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LANGUAGE, TRANSLATIONS_ENABLED } from 'shared/config';

import { resources } from './locales';

export const LANGUAGE_STORAGE_KEY = 'interface-language';
export const supportedLanguages = ['ru', 'en', 'bg'];

const baseLanguage = supportedLanguages.includes(DEFAULT_LANGUAGE) ? DEFAULT_LANGUAGE : 'ru';
const savedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
const initialLanguage =
  TRANSLATIONS_ENABLED && supportedLanguages.includes(savedLanguage) ? savedLanguage : baseLanguage;

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: baseLanguage,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

const applyLanguage = (language) => {
  document.documentElement.lang = language;
  if (TRANSLATIONS_ENABLED) {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  }
};

applyLanguage(initialLanguage);
i18n.on('languageChanged', applyLanguage);

export default i18n;
